import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';

type ResponseCurrentAccountDto = {
    id: string;
    email: string;
    username: string;
    roleId: string;
};

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.query<ResponseCurrentAccountDto, void>({
        query: () => APP_ENDPOINTS.CURRENT_ACCOUNT,
    });
